import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../../contexts/CampaignFlowProvider';

export const useIsInFlowSelector = () => {
  const { state } = useWorkFlowCanvas();

  return useCallback((id: string) => !!state.nodes.find(s => s.id === id), [state.nodes]);
};
